import { render, staticRenderFns } from "./StaffFormPage.vue?vue&type=template&id=5a96bc26&scoped=true"
import script from "./StaffFormPage.vue?vue&type=script&lang=js"
export * from "./StaffFormPage.vue?vue&type=script&lang=js"
import style0 from "./StaffFormPage.vue?vue&type=style&index=0&id=5a96bc26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a96bc26",
  null
  
)

export default component.exports